export const abnormalityRestriction = {
  async: false,
  validate: function(data: any) {
    data = data.original
    if (!data.abnormalities?.length) return true
    if (!data.jobs?.length) return true
    return verification(data.abnormalitiesArray, data)
  },
}
const fnMap = (abnormalities: any) => (job: any) => {
  let result = [] as Object[]
  let abnormalityLength = 0
  abnormalities.map((abnormality: any) => {
    if (abnormality.jobs.length) {
      abnormalityLength++
      if (!restriction(job, abnormality) || !permission(job, abnormality)) {
        result.push(job)
      }
    }
  })
  if (!abnormalityLength) return 0
  if (result.length) return result
  else return 0
}

const restriction = (job: any, abnormality: any) => {
  if (!abnormality.jobs) return true
  if (abnormality.lock_type == "R") {
    const abJob = abnormality.jobs.find((abJob: any) => abJob.id == job.id)
    if (!abJob) return true
    else return false
  }
  return true
}

const permission = (job: any, abnormality: any) => {
  if (!abnormality.jobs) return true
  if (abnormality.lock_type == "P") {
    const abJob = abnormality.jobs.find((abJob: any) => abJob.id == job.id)
    if (abJob) return true
    else return false
  }
  return true
}

const verification = (abnormalities: Object[], data: any) => {
  const promises = data.jobsArray.map(fnMap(abnormalities))

  const error = promises.find((el: any) => !!el) as any
  if (error || error?.length) {
    throw new Error(
      `O serviço (NGs) ${error[0].code} - ${error[0].description} não pode ser adicionando.`
    )
  } else {
    return true
  }
}
